import { Box, IconButton, Line, Text } from "@prismicio/editor-ui"
import { forwardRef } from "react"

import { headerHeight, mainContentMaxWidth } from "../document/documentLayout"
import { useGoToDocumentList } from "../document/documentRouting"

export const MediaLibraryPageHeader = forwardRef<HTMLDivElement>(
  function MediaLibraryPageHeader(_, ref) {
    const goToDocumentList = useGoToDocumentList()

    return (
      <Box
        display="flex"
        flexDirection="column"
        height={headerHeight}
        border={{ bottom: true }}
        backgroundColor="grey2"
      >
        <Line color="purple" />
        <Box justifyContent="center" padding={16}>
          <Box width={mainContentMaxWidth} alignItems="center" gap={16}>
            {/* TODO: Replace with a link to the document list page when all users are migrated to the new document list page. */}
            <IconButton
              icon="arrowBack"
              size="large"
              variant="solid"
              onClick={() => goToDocumentList()}
            />
            <Text variant="bold">Media Library</Text>
            <ActionPortalContainer ref={ref} />
          </Box>
        </Box>
      </Box>
    )
  }
)

const ActionPortalContainer = forwardRef<HTMLDivElement>(
  function ActionPortalContainer(_, ref) {
    return <Box ref={ref} flexGrow={1} padding={{ left: 8 }} />
  }
)
